import type { Layout } from './layout';
import { NUM_BAR, NUM_VAR } from '../constants';

export function drawGrid(ctx: CanvasRenderingContext2D, layout: Layout): void {
  const { originX, originY, side, cellPx } = layout;

  ctx.save();
  ctx.strokeStyle = 'rgba(255,255,255,0.25)';
  ctx.lineWidth = 1;

  // Background panel
  ctx.fillStyle = 'rgba(255,255,255,0.02)';
  ctx.fillRect(originX, originY, side, side);

  ctx.beginPath();
  for (let i = 0; i <= NUM_BAR; i++) {
    const x = Math.round(originX + i * cellPx) + 0.5;
    ctx.moveTo(x, originY);
    ctx.lineTo(x, originY + side);
  }
  for (let j = 0; j <= NUM_VAR; j++) {
    const y = Math.round(originY + j * cellPx) + 0.5;
    ctx.moveTo(originX, y);
    ctx.lineTo(originX + side, y);
  }
  ctx.stroke();

  // every-4 emphasis
  ctx.strokeStyle = 'rgba(255,255,255,0.55)';
  ctx.lineWidth = 1.25;
  ctx.beginPath();
  for (let i = 0; i <= NUM_BAR; i += 4) {
    const x = Math.round(originX + i * cellPx) + 0.5;
    ctx.moveTo(x, originY);
    ctx.lineTo(x, originY + side);
  }
  for (let j = 0; j <= NUM_VAR; j += 4) {
    const y = Math.round(originY + j * cellPx) + 0.5;
    ctx.moveTo(originX, y);
    ctx.lineTo(originX + side, y);
  }
  ctx.stroke();

  ctx.restore();
}
